import MaterialIcon from '@/components/atom/MaterialIcon';
import ImpressionLogger from '@/components/common/ImpressionLogger';
import { Carousel, CarouselApi, CarouselContent, CarouselItem } from '@/dnDesignSystem/components/ui/carousel';
import theme from '@/styles/theme';
import { LoggerParams } from '@/types/log';
import React, { useEffect, useState } from 'react';

const reviews: {
  tagImageUrl: string;
  tagName: string;
  title: string;
  content: string;
  reviewerName: string;
}[] = [
  {
    tagImageUrl: '/images/qna/skincare.png',
    tagName: '여드름/피부염',
    title: '약 타러 가지 않아도 되고, 가격도 저렴해요',
    content:
      '병원 가기 귀찮았는데, 의사 선생님도 친절하고 몸이 잘 듣는 약을 알맞게 처방해주셔서 너무 만족해요. 가격도 저렴해서 꾸준히 이용할 것 같아요!',
    reviewerName: '김OO',
  },
  {
    tagImageUrl: '/images/qna/hairless.png',
    tagName: '탈모',
    title: '종로 성지보다 가격이 저렴해서 만족해요.',
    content:
      '탈모약 가격이 부담돼서 종로 성지 약국을 찾곤 했는데, 이제는 앱으로 비대면 진료받고 처방을 받을 수 있어서 정말 편리해요. 종로가서 진료받는 것보다 가격도 저렴해요.',
    reviewerName: '변OO',
  },
  {
    tagImageUrl: '/images/qna/gynecology.png',
    tagName: '여성질환',
    title: '병원가기 민망했는데 비대면 진료로 해결!',
    content:
      '질염이 정말 지긋지긋한데 병원까지 가기 망설여지더라고요. 산부인과 가면 오래 대기해야하기도 하고요. 자세히 물어봐 주셔서 직접 병원 가서 진료받은 느낌이에요.',
    reviewerName: '지OO',
  },
  {
    tagImageUrl: '/images/qna/cold.png',
    tagName: '감기/몸살',
    title: '병원가기 어려운 직장인에게 최고!',
    content:
      '직장인이라 아프면 반차 내고 병원 가야 해서 번거로웠는데, 점심시간에 앱으로 간편하게 진료를 받고, 근처 약국에서 바로 약까지 받을 수 있어서 정말 편리했어요.',
    reviewerName: '박OO',
  },
];

const QuestionDiagnosisReviews = ({
  loggerParams,
}: {
  loggerParams: LoggerParams;
}) => {
  const [carousel, setCarousel] = useState<CarouselApi | null>(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    if (!carousel) return;

    const updateCarouselState = () => {
      setCurrentIndex(carousel.selectedScrollSnap());
      setTotalItems(carousel.scrollSnapList().length);
    };

    updateCarouselState();

    carousel.on('select', updateCarouselState);

    return () => {
      carousel.off('select', updateCarouselState);
    };
  }, [carousel]);
  return (
    <section className='py-[32px]'>
      <h3 className={'typography-ui-19sb mb-[20px] px-[24px] text-gray-800'}>비대면 진료 실제 후기</h3>
      <ImpressionLogger params={loggerParams}>
        <Carousel setApi={setCarousel} className={'w-full'}>
          <CarouselContent className={'ml-[36px]'}>
            {reviews.map((review, index) => {
              return (
                <CarouselItem key={`carousel-${index}`}>
                  <div
                    className={
                      '-ml-[12px] flex h-full w-[calc(100%-12px)] flex-col rounded-[10px] bg-gray-20 px-[20px] py-[26px]'
                    }
                  >
                    <div className={'mb-[20px] flex items-center'}>
                      {Array.from({ length: 5 }).map((_, i) => {
                        return (
                          <MaterialIcon
                            key={`star-${i}`}
                            name={'star'}
                            color={theme.color.yellow600}
                            size={24}
                            filled
                          />
                        );
                      })}
                    </div>
                    <div
                      className={
                        'mb-[8px] flex w-fit items-center gap-[4px] rounded-[7px] bg-gray-50 px-[6px] py-[4px]'
                      }
                    >
                      <img className={'h-[20px] w-[20px]'} src={review.tagImageUrl} alt={review.tagName} />
                      {review.tagName && <span className={'typography-ui-14sb text-gray-500'}>{review.tagName}</span>}
                    </div>
                    <h4 className={'typography-ui-15sb mb-[4px] text-gray-700'}>{review.title}</h4>
                    <div className={'flex flex-1 flex-col justify-between gap-[20px]'}>
                      <p className={'typography-ui-15r break-words text-gray-500'}>{review.content}</p>
                      <span className={'typography-ui-13r mt-auto block text-gray-300'}>{review.reviewerName} 님</span>
                    </div>
                  </div>
                </CarouselItem>
              );
            })}
          </CarouselContent>
        </Carousel>
      </ImpressionLogger>

      <div className='mt-[20px] flex justify-center gap-[8px]'>
        {Array.from({ length: totalItems }).map((_, index) => (
          <button
            key={`dot-${index}`}
            className={`h-[8px] w-[8px] rounded-full transition-colors ${
              currentIndex === index ? 'bg-primary-600' : 'bg-gray-100'
            }`}
            onClick={() => carousel?.scrollTo(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default QuestionDiagnosisReviews;
